import React from 'react';
import MissingValue from './MissingValue';

/** Person on line one, department (or any secondary text) under it. */
export interface PersonCellProps {
  name?: string | null;
  sub?: React.ReactNode;
  compact?: boolean;
  missingLabel?: string;
}

const PersonCell: React.FC<PersonCellProps> = ({ name, sub, compact, missingLabel }) => {
  if (!name) return <MissingValue label={missingLabel ?? 'unknown'} compact={compact} />;
  return (
    <div style={{ lineHeight: 1.35 }}>
      <span style={{ display: compact ? 'inline' : 'block' }}>{name}</span>
      {sub ? (
        <span style={{ display: compact ? 'inline' : 'block', fontSize: 11.5, color: '#8a94a6', marginLeft: compact ? 6 : 0, marginTop: compact ? 0 : 1 }}>
          {sub}
        </span>
      ) : null}
    </div>
  );
};

export default PersonCell;
